export default __webpack_public_path__ + "static/APP_3_1-5d7af8c872b83f490c557fffd53e92cb.png";